import { render, staticRenderFns } from "./SanitasSearchResult.vue?vue&type=template&id=2a6118e5&"
import script from "./SanitasSearchResult.vue?vue&type=script&lang=js&"
export * from "./SanitasSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SanitasSearchResult.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports